import React, { useEffect, useState } from 'react'
import DashboardLayout from '../DashboardLayout'
import CustomTabs from '../../CustomTabs'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import FullScreenLoader from '../../FullScreenLoader'

type Props = {
  breadcrumbData?: any
  defaultIndex?: any
  children: any
}

const UserManagementLayout = (props: Props) => {
  const { breadcrumbData, children, defaultIndex } = props
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams()
  const { name, id } = params
  const [defaultTabIndex, setDefaultTabIndex] = useState<number | null>(defaultIndex || null)
  useEffect(() => {
    const ind = ['users', 'user-role']?.findIndex(
      (p: string) => p === location?.pathname?.split('/')?.filter((p: string) => p !== id)[location?.pathname?.split('/')?.filter((p: string) => p !== id)?.length - 1],
    )
    setDefaultTabIndex(ind)
  }, [])
  const getURL = (slug: string) => {
    return `/user-management/${slug}`
  }
  return (
    <DashboardLayout breadcrumbData={breadcrumbData}>
      <div className="grid grid-cols-12 h-full">
        <div className="col-span-12">
          {defaultTabIndex === null ? (
            <FullScreenLoader loading={true} />
          ) : (
            <CustomTabs
              handleClick={(e: string) => navigate(e)}
              tabs={[
                {
                  label: 'Users',
                  component: children,
                  value: getURL('users'),
                },
                {
                  label: 'User Role',
                  component: children,
                  value: getURL('user-role'),
                },
              ]}
              defaultTabIndex={defaultTabIndex || 0}
            />
          )}
        </div>
      </div>
    </DashboardLayout>
  )
}

export default UserManagementLayout
